import produce from 'immer';

import {
  TConfig,
  TConfigInput,
  TConfigParams,
  TGetAddOns,
} from '@@/auto/interfaces';
import { excludeFalse } from '@@/auto/utils/excludeFalse';

import { featureFlag } from '../../featureFlags';

function ToyotaPAConfig({
  isFeatureEnabled,
}: TConfigParams): DeepPartial<TConfigInput> {
  return isFeatureEnabled(featureFlag.IS_PA_TAI_ENABLED)
    ? {
        auto: (auto: TConfig['auto']) =>
          produce(auto, (draft) => {
            draft.addOns.getAddOns = ({
              userAction,
            }: Parameters<TGetAddOns>[0]) =>
              excludeFalse([
                'towing_road_services',
                'temporary_ride',
                'side_hustle',
                'oem_parts',
                'new_car_replacement',
                userAction === 'editing-addons' && 'pet_passenger',
              ] as const);
          }),
        visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) =>
          produce(visibleCoverages, (draft) => {
            draft.protectionCoverages.filter(
              ({ key }) => key !== 'underinsured_motorist_bodily_injury_limit'
            );
          }),
      }
    : {};
}
export default ToyotaPAConfig;
